import React, { Component } from "react";
import ShiftConfiguration from "../../../components/ShiftConfiguration/ShiftConfiguration";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AShiftConfigurationForm
Description : Componente que invoca al componente ShiftConfiguration.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ShiftConfigurationForm extends Component {
    render() {
        return (
            <ShiftConfiguration />
        )
    }
}

export default ShiftConfigurationForm;